{
  "hero": {
    "loading": "Inhalt wird geladen...",
    "headline": {
      "line1": "Strategischer Content für Unternehmen.",
      "line2": "Effizienz und Professionalität im digitalen Marketing"
    },
    "subheadline": "Technologie, Design und Videografie — integriert, um konkrete Geschäftsprobleme zu lösen",
    "primaryCta": "Projekte ansehen",
    "secondaryCta": "Strategiesitzung in Timișoara vereinbaren"
  },
  "hook": "Die Investition in Videoinhalte ist kein Trend, sondern eine strategische Entscheidung für Wachstum und Positionierung in einem wettbewerbsintensiven Markt.",
  "industry": {
    "title": "Medienlösungen nach Branche",
    "options": {
      "ecommerce": "E-Commerce-Unternehmen",
      "restaurants": "Restaurants und Cafés",
      "retail": "Einzelhandel",
      "salons": "Salons und Spas",
      "fitness": "Fitnesscenter und Studios",
      "realestate": "Immobilienmakler",
      "professional": "Professionelle Dienstleistungen",
      "homeservices": "Haushaltsnahe Dienste"
    }
  },
  "problem": {
    "heading": "Warum die meisten digitalen Projekte nicht ankommen.",
    "copy": "Entwicklung, Design und Videografie werden häufig getrennt vergeben. Das Ergebnis: eine fragmentierte Marke ohne gemeinsame Richtung. Nach zwei Jahrzehnten digitaler Projekte zeigt sich ein Muster — technisch solide Websites mit inhaltlicher Leere. Khromatik wurde gegründet, um dieses Problem zu lösen."
  },
  "pillars": {
    "architect": {
      "title": "Der Architekt",
      "subtitle": "Beratung",
      "description": "UI/UX-Audits und Frontend-Architektur für komplexe Plattformen. Senior-Expertise für anspruchsvolle Vorhaben."
    },
    "builder": {
      "title": "Der Erbauer",
      "subtitle": "Entwicklung",
      "description": "Markenidentitäten und hochperformante Websites, ausgelegt auf Conversion."
    },
    "storyteller": {
      "title": "Der Geschichtenerzähler",
      "subtitle": "Content",
      "description": "Filmische Videos und Fotografie, vor Ort in Timișoara produziert, um Technologie eine menschliche Dimension zu geben."
    }
  },
  "holisticEdge": {
    "heading": "Eine klare Vision. Präzise Umsetzung.",
    "workflow": {
      "strategy": "Strategie",
      "design": "Design",
      "code": "Code",
      "content": "Content",
      "launch": "Launch"
    },
    "valueProposition": "Video und Entwicklung aus einer Vision: die Website entsteht um die Geschichte herum — nicht umgekehrt."
  },
  "socialProof": {
    "heading": "20 Jahre Erfahrung",
    "recommendations": {
      "heading": "Empfehlungen"
    },
    "companies": [
      "2trde",
      "Testbirds",
      "GitDigest",
      "HireMeMate",
      "Polestar"
    ],
    "featuredProject": {
      "title": "Empfohlenes Projekt",
      "projectTitle": "Launch der Polestar-Partnerschaft",
      "description": "Komplette Kampagne: Branding, Website und Video aus einer Vision.",
      "cta": "Fallstudie ansehen"
    }
  },
  "localPresence": {
    "heading": "Erstklassige Qualität, lokale Umsetzung",
    "copy": "Studio mit Sitz in Timișoara: Qualität auf westlichem Marktniveau und direkte, lokale Zusammenarbeit. Vom Content-Tag im Büro in Arad bis zum UI-Workshop in Timișoara — kreative Abteilung auf Abruf."
  },
  "packages": {
    "heading": "Kooperationsmodelle",
    "audit": {
      "title": "Das Audit",
      "description": "Schnelles Ergebnis für große Unternehmen. UI/UX-Audit und strategische Empfehlungen.",
      "cta": "Details"
    },
    "launch": {
      "title": "Der Launch",
      "description": "Für neue Marken. Vollständige digitale Identität von der Konzeption bis zum Launch.",
      "cta": "Details"
    },
    "partnership": {
      "title": "Die Partnerschaft",
      "description": "Monatlicher Content-Retainer. Kontinuierliche Unterstützung für wachsende Unternehmen.",
      "cta": "Details"
    }
  },
  "footerCta": {
    "heading": "Einheitliche digitale Präsenz — von der Strategie bis zur Umsetzung.",
    "contactText": "Gespräch zum Projekt",
    "bookSession": "Strategiesitzung vereinbaren",
    "or": "oder",
    "contactLink": "Kontakt"
  }
}
